module.exports = __webpack_public_path__ + "static/img/wine_background.5c6853f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/wine_background.jpg
// module id = TI3H
// module chunks = 0